export default "/images/blog_masonry_tile_gradient.png?8ff472cf98798347cc6d2fe4179cb2cd";